import SymptomsCheckerMessage from './SymptomsCheckerMessage';

export default SymptomsCheckerMessage;
